
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="prose prose-lg max-w-none">
            <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
            <p className="text-gray-600 mb-8">Last updated: {new Date().toLocaleDateString()}</p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Information We Collect</h2>
              <p className="text-gray-700 mb-4">
                At Fast Funding Capital, we collect information you provide directly to us, such as when you:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Fill out our pre-approval application form</li>
                <li>Contact us through our website or phone</li>
                <li>Subscribe to our newsletter or updates</li>
                <li>Request information about our loan products</li>
              </ul>
              <p className="text-gray-700 mb-4">
                The types of information we may collect include:
              </p>
              <ul className="list-disc pl-6 text-gray-700">
                <li>Personal information (name, email address, phone number)</li>
                <li>Financial information (income, assets, credit information)</li>
                <li>Property information (address, purchase price, purchase price)</li>
                <li>Business information (company name, years in business)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. How We Use Your Information</h2>
              <p className="text-gray-700 mb-4">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 text-gray-700">
                <li>Process your loan applications and pre-approval requests</li>
                <li>Connect you with appropriate lenders in our network</li>
                <li>Communicate with you about our services and loan products</li>
                <li>Provide customer support and respond to your inquiries</li>
                <li>Improve our website and services</li>
                <li>Comply with legal and regulatory requirements</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Information Sharing and Disclosure</h2>
              <p className="text-gray-700 mb-4">
                We may share your information with:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li><strong>Lenders:</strong> We share your application information with lenders in our network to facilitate loan processing</li>
                <li><strong>Service Providers:</strong> Third-party companies that help us operate our business (credit reporting agencies, verification services)</li>
                <li><strong>Legal Requirements:</strong> When required by law, regulation, or legal process</li>
                <li><strong>Business Transfers:</strong> In connection with any merger, sale, or transfer of our business</li>
              </ul>
              <p className="text-gray-700">
                We do not sell, rent, or trade your personal information to third parties for marketing purposes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Data Security</h2>
              <p className="text-gray-700 mb-4">
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. These measures include:
              </p>
              <ul className="list-disc pl-6 text-gray-700">
                <li>Encryption of sensitive data during transmission</li>
                <li>Secure servers and databases</li>
                <li>Regular security assessments and updates</li>
                <li>Limited access to personal information on a need-to-know basis</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Data Retention</h2>
              <p className="text-gray-700">
                We retain your personal information for as long as necessary to fulfill the purposes outlined in this privacy policy, unless a longer retention period is required or permitted by law. Loan application data may be retained for up to 7 years in accordance with financial industry regulations.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Your Rights and Choices</h2>
              <p className="text-gray-700 mb-4">
                You have the right to:
              </p>
              <ul className="list-disc pl-6 text-gray-700">
                <li>Access and review the personal information we have about you</li>
                <li>Request corrections to inaccurate or incomplete information</li>
                <li>Request deletion of your personal information (subject to legal requirements)</li>
                <li>Opt out of marketing communications</li>
                <li>Withdraw consent where processing is based on consent</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Cookies and Tracking Technologies</h2>
              <p className="text-gray-700 mb-4">
                Our website uses cookies and similar tracking technologies to:
              </p>
              <ul className="list-disc pl-6 text-gray-700">
                <li>Remember your preferences and settings</li>
                <li>Analyze website traffic and usage patterns</li>
                <li>Improve our website functionality and user experience</li>
                <li>Provide personalized content and advertisements</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Third-Party Links</h2>
              <p className="text-gray-700">
                Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to review the privacy policies of any third-party websites you visit.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Children's Privacy</h2>
              <p className="text-gray-700">
                Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children under 18. If we become aware that we have collected personal information from a child under 18, we will take steps to delete such information.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Changes to This Privacy Policy</h2>
              <p className="text-gray-700">
                We may update this privacy policy from time to time to reflect changes in our practices or applicable laws. We will notify you of any material changes by posting the updated policy on our website and updating the "Last updated" date.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Contact Us</h2>
              <p className="text-gray-700 mb-4">
                If you have any questions about this privacy policy or our privacy practices, please contact us:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-2"><strong>Fast Funding Capital</strong></p>
                <p className="text-gray-700 mb-2">2100 West Loop S Suite 800, Houston, TX 77027</p>
                <p className="text-gray-700 mb-2">Phone: 346.291.8220</p>
                <p className="text-gray-700">Email: info@fastfundingcap.com</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. State-Specific Rights</h2>
              <p className="text-gray-700 mb-4">
                <strong>California Residents:</strong> Under the California Consumer Privacy Act (CCPA), you have additional rights including the right to know what personal information we collect, the right to delete personal information, and the right to opt-out of the sale of personal information.
              </p>
              <p className="text-gray-700">
                <strong>Other States:</strong> Residents of other states may have additional privacy rights under applicable state laws. Please contact us to learn more about your specific rights.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">13. SMS Messaging Consent</h2>
              <p className="text-gray-700 mb-4">
                By providing your phone number on our website, you consent to receive SMS messages from Fast Funding Capital related to services and account updates. Message frequency may vary. Standard message and data rates may apply. You may opt out at any time by replying STOP to any message.
              </p>
              <p className="text-gray-700">
                For assistance with SMS messages, you can reply HELP to any message or contact us directly at 346.291.8220 or info@fastfundingcap.com.
              </p>
            </section>

          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
